import { render, staticRenderFns } from "./Floor.vue?vue&type=template&id=25456fe6"
import script from "./Floor.vue?vue&type=script&lang=js"
export * from "./Floor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports